(function () {
  'use strict';

  const SECTION_SELECTOR = '.lab9-mac-choice-helper';
  const MOBILE_QUERY = '(max-width: 749px)';

  function getSections(root) {
    const sections = [];

    if (root && root.matches && root.matches(SECTION_SELECTOR)) {
      sections.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
        if (!sections.includes(section)) {
          sections.push(section);
        }
      });
    }

    return sections;
  }

  function parseJsonElement(element, errorMessage) {
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error(errorMessage, error);
      return null;
    }
  }

  /* ==========================================
     PRODUCT DATA LAYER
     Shopify products -> recommendation models
     ========================================== */

  function normalizeChip(value) {
    if (!value) return '';

    const cleaned = String(value)
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const match = cleaned.match(
      /\b([MA]\d+(?:\s+(?:Pro|Max|Ultra))?)\b/i
    );

    if (!match) return cleaned;

    return match[1]
      .replace(/\s+/g, ' ')
      .replace(/\bpro\b/i, 'Pro')
      .replace(/\bmax\b/i, 'Max')
      .replace(/\bultra\b/i, 'Ultra');
  }

  function getScreenSize(product) {
    const source = [
      product.baseHandle,
      product.baseTitle,
      product.title
    ]
      .filter(Boolean)
      .join(' ');

    const match = source.match(/\b(13|14|15|16|24)[-\s]?inch\b/i);
    return match ? match[1] : '';
  }

  function buildModelName(model) {
    const parts = [model.family];

    if (model.screenSize) {
      parts.push(model.screenSize + '″');
    }

    if (model.chip) {
      parts.push(model.chip);
    }

    return parts.join(' ');
  }

  function buildMacModels(products) {
    const models = new Map();

    products.forEach(function (product) {
      const chip = normalizeChip(product.chip);
      const screenSize = getScreenSize(product);
      const key = [
        product.familyHandle,
        product.baseHandle,
        chip
      ].join('|');

      if (!models.has(key)) {
        models.set(key, {
          family: product.family,
          familyHandle: product.familyHandle,
          baseHandle: product.baseHandle,
          baseTitle: product.baseTitle,
          chip: chip,
          screenSize: screenSize,
          price: product.price,
          compareAtPrice: product.compareAtPrice || 0,
          image: product.image || '',
          productUrl: product.url,
          collectionUrl: '/collections/' + product.familyHandle,
          configurations: 1
        });
        return;
      }

      const model = models.get(key);
      model.configurations += 1;

      if (product.price < model.price) {
        model.price = product.price;
        model.compareAtPrice = product.compareAtPrice || 0;
        model.image = product.image || model.image;
        model.productUrl = product.url;
      }
    });

    return Array.from(models.values())
      .map(function (model) {
        model.name = buildModelName(model);
        return model;
      })
      .sort(function (a, b) {
        if (a.familyHandle === b.familyHandle) {
          return a.price - b.price;
        }
        return a.family.localeCompare(b.family);
      });
  }

  function initMacProductData(section) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const dataElement = document.querySelector(
      '[data-mac-products="' + sectionId + '"]'
    );

    const products = parseJsonElement(
      dataElement,
      'Lab9 Mac keuzehulp: product JSON kon niet worden gelezen.'
    );

    if (!Array.isArray(products)) return;

    window.Lab9MacChoiceModels = window.Lab9MacChoiceModels || {};
    window.Lab9MacChoiceModels[sectionId] = buildMacModels(products);
  }

  /* ==========================================
     CHOICE HELPER
     ========================================== */

  function initMacChoiceHelper(section) {
    if (section.dataset.initialized === 'true') return;

    const mount = section.querySelector('[data-mac-choice-helper]');
    const sectionId = section.dataset.sectionId;
    const copyElement = section.querySelector(
      '[data-mac-choice-copy="' + sectionId + '"]'
    );

    if (!mount || !copyElement) return;

    const copy = parseJsonElement(
      copyElement,
      'Lab9 Mac keuzehulp: interfacecopy kon niet worden gelezen.'
    );

    if (!copy) return;

    section.dataset.initialized = 'true';

    const welcomeHtml = mount.innerHTML;
    const state = {
      mode: 'full',
      step: 0,
      answers: {}
    };

    function getQuestions() {
      let questions = [
        {
          key: 'place',
          title: copy.questions.place.title,
          help: copy.questions.place.help,
          options: copy.questions.place.options
        },
        {
          key: 'use',
          title: copy.questions.use.title,
          help: copy.questions.use.help,
          options: copy.questions.use.options
        },
        {
          key: 'intensity',
          title: copy.questions.intensity.title,
          help: copy.questions.intensity.help,
          options: copy.questions.intensity.options
        },
        {
          key: 'screen',
          title: copy.questions.screen.title,
          help: copy.questions.screen.help,
          options: copy.questions.screen.options
        },
        {
          key: 'priority',
          title: copy.questions.priority.title,
          help: copy.questions.priority.help,
          options: copy.questions.priority.options
        },
        {
          key: 'budget',
          title: copy.questions.budget.title,
          help: copy.questions.budget.help,
          options: copy.questions.budget.options
        }
      ];

      if (state.mode === 'portable') {
        questions = questions.filter(function (question) {
          return question.key !== 'place';
        });

        questions = questions.map(function (question) {
          if (question.key !== 'screen') return question;

          return {
            key: 'screen',
            title: copy.questions.portableScreen.title,
            help: copy.questions.portableScreen.help,
            options: copy.questions.portableScreen.options
          };
        });
      }

      if (state.mode === 'desktop') {
        questions = questions.filter(function (question) {
          return question.key !== 'place';
        });

        questions = questions.map(function (question) {
          if (question.key === 'screen') {
            return {
              key: 'screen',
              title: copy.questions.desktopScreen.title,
              help: copy.questions.desktopScreen.help,
              options: copy.questions.desktopScreen.options
            };
          }

          if (question.key === 'priority') {
            return {
              ...question,
              options: question.options.filter(function (option) {
                return option.value !== 'mobility';
              })
            };
          }

          return question;
        });
      }

      if (state.mode === 'full' && state.answers.place === 'desk') {
        questions = questions.map(function (question) {
          if (question.key !== 'priority') return question;

          return {
            ...question,
            options: question.options.filter(function (option) {
              return option.value !== 'mobility';
            })
          };
        });
      }

      return questions;
    }

    function createAnswer(option, selectedValue) {
      const selected = option.value === selectedValue ? ' is-selected' : '';

      return `
        <button
          type="button"
          class="lab9-mac-choice-helper__answer${selected}"
          data-mac-choice-answer="${option.value}"
        >
          <strong>${option.title}</strong>
          <span>${option.text}</span>
        </button>
      `;
    }

    function getStickyHeaderOffset() {
  const candidates = document.querySelectorAll(
    'header, sticky-header, #shopify-section-header, .header-wrapper, .shopify-section-header-sticky'
  );

  let activeOffset = 0;
  let fallbackHeight = 0;

  candidates.forEach(function (element) {
    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    const stickyOrFixed =
      styles.position === 'sticky' ||
      styles.position === 'fixed';

    if (!stickyOrFixed) return;

    /*
     * Onthoud de hoogte ook wanneer de header
     * nog niet effectief sticky staat.
     *
     * Dit voorkomt de verkeerde positie bij
     * de eerste overgang van vraag 1 naar vraag 2.
     */
    if (rect.height > 0) {
      fallbackHeight = Math.max(
        fallbackHeight,
        rect.height
      );
    }

    const visibleAtTop =
      rect.bottom > 0 &&
      rect.top <= 5;

    if (visibleAtTop) {
      activeOffset = Math.max(
        activeOffset,
        rect.bottom
      );
    }
  });

  /*
   * Staat de header al sticky?
   * Gebruik zijn echte positie.
   *
   * Zo niet, gebruik alvast zijn bekende hoogte.
   */
  return Math.max(
    0,
    activeOffset || fallbackHeight
  );
}

    function scrollMacChoiceToTop() {
  if (!mount) return;

  const extraGap =
    window.innerWidth <= 749
      ? 24
      : 32;

  window.setTimeout(function () {
    const absoluteTop =
      mount.getBoundingClientRect().top +
      window.pageYOffset;

    const headerOffset =
      getStickyHeaderOffset();

    /*
     * Alleen vraag 2 krijgt een kleine extra correctie.
     * Op dat moment verandert de Lab9-header voor het eerst
     * naar zijn sticky toestand.
     */
    const questionTwoCorrection =
  state.step === 1
    ? (
        window.innerWidth <= 749
          ? 40
          : 56
      )
    : 0;

    const targetTop =
      absoluteTop -
      headerOffset -
      extraGap -
      questionTwoCorrection;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });
  }, 80);
}

    function renderQuestion() {
      const questions = getQuestions();
      const question = questions[state.step];

      if (!question) return;

      const validValues = question.options.map(function (option) {
        return option.value;
      });

      if (
        state.answers[question.key] &&
        !validValues.includes(state.answers[question.key])
      ) {
        delete state.answers[question.key];
      }

      const currentAnswer = state.answers[question.key];

      const progress = questions
        .map(function (_, index) {
          return `<span class="${index <= state.step ? 'is-active' : ''}"></span>`;
        })
        .join('');

      const options = question.options
        .map(function (option) {
          return createAnswer(option, currentAnswer);
        })
        .join('');

      mount.innerHTML = `
        <div class="lab9-mac-choice-helper__wizard">
          <div class="lab9-mac-choice-helper__progress">${progress}</div>

          <div class="lab9-mac-choice-helper__question-header">
            <span class="lab9-mac-choice-helper__counter">
              ${copy.labels.question} ${state.step + 1} ${copy.labels.of} ${questions.length}
            </span>
            <h2>${question.title}</h2>
            <p>${question.help}</p>
          </div>

          <div class="lab9-mac-choice-helper__answers">${options}</div>

          <div class="lab9-mac-choice-helper__navigation">
            <button
              type="button"
              class="lab9-mac-choice-helper__secondary-button"
              data-mac-choice-back
            >
              ${copy.labels.previous}
            </button>

            <button
              type="button"
              class="lab9-mac-choice-helper__primary-button"
              data-mac-choice-next
              ${currentAnswer ? '' : 'disabled'}
            >
              ${
                state.step === questions.length - 1
                  ? copy.labels.result
                  : copy.labels.next
              }
            </button>
          </div>
        </div>
      `;

      scrollMacChoiceToTop();
    }

    function renderWelcome() {
      state.step = 0;
      state.mode = 'full';
      state.answers = {};
      mount.innerHTML = welcomeHtml;
      scrollMacChoiceToTop();
    }

    function getRecommendationModels() {
      if (
        !window.Lab9MacChoiceModels ||
        !window.Lab9MacChoiceModels[sectionId]
      ) {
        return [];
      }

      return window.Lab9MacChoiceModels[sectionId];
    }

    function isPortableModel(model) {
      return ['macbook-neo', 'macbook-air', 'macbook-pro'].includes(
        model.familyHandle
      );
    }

    function getChipPerformance(chip) {
      const value = String(chip || '').trim();

      if (/^A/i.test(value)) {
        if (/A18\s*Pro/i.test(value)) return 1.3;
        return 1.1;
      }

      const match = value.match(/^M(\d+)(?:\s+(Pro|Max|Ultra))?/i);
      if (!match) return 1;

      const generation = Number(match[1]);
      const tier = String(match[2] || '').toLowerCase();
      const tierScores = {
        '': 2.0,
        pro: 3.1,
        max: 4.0,
        ultra: 4.8
      };

      const baseScore = tierScores[tier] ?? 2.0;
      const generationBonus = Math.max(0, generation - 3) * 0.15;

      return baseScore + generationBonus;
    }

    function getRequiredPerformance() {
      const useScores = {
        daily: 1,
        study: 1.2,
        office: 1.5,
        code: 2.2,
        photo: 2.4,
        video: 3,
        audio: 2.5,
        design: 3.2
      };

      const intensityAdjustments = {
        light: -0.2,
        regular: 0.5,
        pro: 1.2
      };

      const base = useScores[state.answers.use] || 1.5;
      const adjustment = intensityAdjustments[state.answers.intensity] || 0;

      return Math.max(1, Math.min(5, base + adjustment));
    }

    function getFamilyUseFit(familyHandle, use) {
      const scores = {
        'macbook-neo': {
          daily: 6,
          study: 6,
          office: 4,
          code: 0,
          photo: -1,
          video: -5,
          audio: 0,
          design: -6
        },
        'macbook-air': {
          daily: 5,
          study: 6,
          office: 6,
          code: 4,
          photo: 4,
          video: 1,
          audio: 3,
          design: 0
        },
        'macbook-pro': {
          daily: 2,
          study: 2,
          office: 3,
          code: 7,
          photo: 8,
          video: 9,
          audio: 7,
          design: 9
        },
        'mac-mini': {
          daily: 4,
          study: 3,
          office: 5,
          code: 6,
          photo: 5,
          video: 4,
          audio: 7,
          design: 3
        },
        imac: {
          daily: 5,
          study: 3,
          office: 6,
          code: 4,
          photo: 6,
          video: 3,
          audio: 4,
          design: 4
        },
        'mac-studio': {
          daily: -5,
          study: -5,
          office: -3,
          code: 5,
          photo: 7,
          video: 10,
          audio: 8,
          design: 10
        }
      };

      return scores[familyHandle]?.[use] || 0;
    }

    function getBudgetCeiling() {
      const budgets = {
        '1000': 100000,
        '1500': 150000,
        '2000': 200000,
        '3000': 300000
      };

      return budgets[state.answers.budget] || null;
    }

    function scoreRecommendationModel(model) {
      const portable = isPortableModel(model);
      const answers = state.answers;

      if (state.mode === 'portable' && !portable) return null;
      if (state.mode === 'desktop' && portable) return null;

      if (
        state.mode === 'full' &&
        answers.place === 'mobile' &&
        !portable
      ) {
        return null;
      }

      let score = 50;
      score += getFamilyUseFit(model.familyHandle, answers.use);

      const requiredPerformance = getRequiredPerformance();
      const modelPerformance = getChipPerformance(model.chip);

      if (modelPerformance < requiredPerformance) {
        score -= (requiredPerformance - modelPerformance) * 7;
      } else {
        const extraPerformance = modelPerformance - requiredPerformance;

        if (answers.priority === 'performance') {
          score += extraPerformance * 1.5;
        }

        if (answers.priority === 'value') {
          score -= extraPerformance * 0.7;
        }

        if (answers.priority === 'balance') {
          score += Math.min(extraPerformance, 1.5) * 0.4;
        }
      }

      if (state.mode === 'full') {
        if (answers.place === 'mobile') score += portable ? 6 : 0;
        if (answers.place === 'mixed') score += portable ? 5 : 0;
        if (answers.place === 'desk') score += portable ? 1 : 5;
      }

      const screenSize = Number(model.screenSize || 0);

      if (answers.screen === 'compact') {
        if (portable && [13, 14].includes(screenSize)) {
          score += 4;
        } else if (portable) {
          score -= 2;
        } else {
          score -= 3;
        }
      }

      if (answers.screen === 'large') {
        if (portable) {
          if ([15, 16].includes(screenSize)) {
            score += 8;
          } else if ([13, 14].includes(screenSize)) {
            score -= 7;
          }
        }

        if (model.familyHandle === 'imac') score += 7;

        if (
          model.familyHandle === 'mac-mini' ||
          model.familyHandle === 'mac-studio'
        ) {
          score += 3;
        }
      }

      if (answers.screen === 'external') {
        if (
          model.familyHandle === 'mac-mini' ||
          model.familyHandle === 'mac-studio'
        ) {
          score += 6;
        }

        if (model.familyHandle === 'imac') score -= 4;
        if (portable) score += 1;
      }

      if (answers.screen === 'integrated') {
        if (model.familyHandle === 'imac') score += 8;
        if (portable) score += 2;

        if (
          model.familyHandle === 'mac-mini' ||
          model.familyHandle === 'mac-studio'
        ) {
          score -= 5;
        }
      }

      if (answers.priority === 'mobility') {
        if (model.familyHandle === 'macbook-air') {
          score += 7;
        } else if (model.familyHandle === 'macbook-neo') {
          score += 6;
        } else if (model.familyHandle === 'macbook-pro') {
          score += 3;
        } else {
          score -= 10;
        }
      }

      if (answers.priority === 'performance') {
        score += modelPerformance * 1.5;

        if (
          model.familyHandle === 'macbook-pro' ||
          model.familyHandle === 'mac-studio'
        ) {
          score += 3;
        }
      }

      if (answers.priority === 'balance') {
        if (model.familyHandle === 'macbook-air') score += 4;

        if (
          model.familyHandle === 'mac-mini' ||
          model.familyHandle === 'imac'
        ) {
          score += 3;
        }

        if (model.familyHandle === 'macbook-neo') score += 2;
        if (model.familyHandle === 'macbook-pro') score += 1;
        if (model.familyHandle === 'mac-studio') score -= 2;
      }

      const budget = getBudgetCeiling();

      if (budget) {
        if (model.price <= budget) {
          score += 3;
        } else {
          const amountOverBudget = (model.price - budget) / 50000;
          score -= 5 + amountOverBudget * 4;
        }
      }

      return {
        model: model,
        score: score
      };
    }

    function rankRecommendationModels() {
      const models = getRecommendationModels();
      const scored = models
        .map(scoreRecommendationModel)
        .filter(Boolean);

      if (state.answers.priority === 'value' && scored.length > 1) {
        const prices = scored.map(function (item) {
          return item.model.price;
        });
        const minPrice = Math.min.apply(null, prices);
        const maxPrice = Math.max.apply(null, prices);
        const priceRange = maxPrice - minPrice;

        scored.forEach(function (item) {
          if (priceRange > 0) {
            const relativeValue =
              (maxPrice - item.model.price) / priceRange;
            item.score += relativeValue * 6;
          }

          if (
            item.model.compareAtPrice &&
            item.model.compareAtPrice > item.model.price
          ) {
            const discount =
              (item.model.compareAtPrice - item.model.price) /
              item.model.compareAtPrice;
            item.score += Math.min(2.5, discount * 10);
          }
        });
      }

      return scored
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return a.model.price - b.model.price;
        })
        .slice(0, 3);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function isFrenchLocale() {
      return String(section.dataset.locale || '')
        .toLowerCase()
        .startsWith('fr');
    }

    function formatPrice(cents) {
      return new Intl.NumberFormat(isFrenchLocale() ? 'fr-BE' : 'nl-BE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
      }).format((Number(cents) || 0) / 100);
    }

    function getLocalizedMacPath(path, isFrench) {
      if (!path) return '#';
      if (/^https?:\/\//i.test(path)) return path;
      if (!isFrench) return path;
      if (path === '/fr' || path.indexOf('/fr/') === 0) return path;
      return '/fr' + path;
    }

    function getMacResultReasons(model, isFrench) {
      const answers = state.answers;
      const reasons = [];

      const familyReasons = isFrench
        ? {
            'macbook-neo':
              'Un Mac portable accessible pour les études et les tâches du quotidien.',
            'macbook-air':
              'Un excellent équilibre entre mobilité et performances.',
            'macbook-pro':
              'Conçu pour les workflows créatifs et professionnels plus exigeants.',
            'mac-mini':
              'Des performances Mac pour un poste fixe avec l’écran de votre choix.',
            imac:
              'Un ordinateur de bureau complet avec Mac et écran 24 pouces en un.',
            'mac-studio':
              'Pensé pour les workflows créatifs professionnels les plus exigeants.'
          }
        : {
            'macbook-neo':
              'Een toegankelijke, draagbare Mac voor studie en dagelijkse taken.',
            'macbook-air':
              'Een sterke balans tussen mobiliteit en prestaties.',
            'macbook-pro':
              'Gemaakt voor zwaardere creatieve en professionele workflows.',
            'mac-mini':
              'Veel Mac-prestaties voor een vaste werkplek met je eigen scherm.',
            imac:
              'Een complete desktop met Mac en 24-inch scherm in één.',
            'mac-studio':
              'Gericht op de zwaarste professionele creatieve workflows.'
          };

      if (familyReasons[model.familyHandle]) {
        reasons.push(familyReasons[model.familyHandle]);
      }

      const screenSize = Number(model.screenSize || 0);
      const portable = isPortableModel(model);

      if (
        answers.screen === 'compact' &&
        portable &&
        [13, 14].includes(screenSize)
      ) {
        reasons.push(
          isFrench
            ? `Son écran ${screenSize}″ correspond à votre préférence pour un format compact.`
            : `Het ${screenSize}″ scherm past bij je voorkeur voor een compact formaat.`
        );
      }

      if (
        answers.screen === 'large' &&
        portable &&
        [15, 16].includes(screenSize)
      ) {
        reasons.push(
          isFrench
            ? `Son écran ${screenSize}″ vous offre l’espace de travail que vous recherchez.`
            : `Het ${screenSize}″ scherm geeft je de extra werkruimte die je zoekt.`
        );
      }

      if (
        answers.screen === 'external' &&
        !portable &&
        model.familyHandle !== 'imac'
      ) {
        reasons.push(
          isFrench
            ? 'Il s’intègre parfaitement à un poste de travail avec votre propre écran.'
            : 'Past perfect in een vaste werkplek met je eigen display.'
        );
      }

      if (answers.screen === 'integrated' && model.familyHandle === 'imac') {
        reasons.push(
          isFrench
            ? 'Vous avez choisi une solution complète avec écran intégré.'
            : 'Je koos voor een complete desktop met ingebouwd scherm.'
        );
      }

      if (answers.priority === 'performance') {
        reasons.push(
          isFrench
            ? `${model.chip} correspond à votre priorité donnée aux performances.`
            : `${model.chip} sluit aan bij je focus op prestaties.`
        );
      }

      if (answers.priority === 'value') {
        reasons.push(
          isFrench
            ? 'Un excellent rapport entre performances et prix pour votre profil.'
            : 'Een sterke prijs-prestatieverhouding voor jouw gebruik.'
        );
      }

      if (answers.priority === 'mobility' && portable) {
        reasons.push(
          isFrench
            ? 'Un choix portable qui correspond à votre besoin de mobilité.'
            : 'Een draagbare keuze die aansluit bij je behoefte aan mobiliteit.'
        );
      }

      if (answers.priority === 'balance') {
        reasons.push(
          isFrench
            ? 'Un choix équilibré pour vos besoins quotidiens.'
            : 'Een evenwichtige keuze voor je dagelijkse gebruik.'
        );
      }

      const budget = getBudgetCeiling();

      if (budget && model.price <= budget && reasons.length < 3) {
        reasons.push(
          isFrench
            ? `À partir de ${formatPrice(model.price)}, il respecte votre budget.`
            : `Vanaf ${formatPrice(model.price)} past hij binnen je gekozen budget.`
        );
      }

      return Array.from(new Set(reasons)).slice(0, 3);
    }

    function getMacBenefitIcon(type) {
      const icons = {
        warranty: `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3 19 6v5c0 4.6-2.9 8-7 10-4.1-2-7-5.4-7-10V6l7-3Z"/>
            <path d="m9 12 2 2 4-4"/>
          </svg>
        `,
        lessons: `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m3 9 9-5 9 5-9 5-9-5Z"/>
            <path d="M7 12.5V17c3 2 7 2 10 0v-4.5"/>
            <path d="M21 9v6"/>
          </svg>
        `,
        tradein: `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 7h10"/>
            <path d="m14 4 3 3-3 3"/>
            <path d="M17 17H7"/>
            <path d="m10 20-3-3 3-3"/>
          </svg>
        `,
        financing: `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2"/>
            <path d="M3 9h18"/>
            <path d="M7 15h4"/>
          </svg>
        `
      };

      return `
        <span class="lab9-mac-choice-helper__benefit-icon">
          ${icons[type] || ''}
        </span>
      `;
    }

    function getStoreAdviceConfig(isFrench) {
      const element = document.querySelector(
        '[data-mac-store-advice="' + sectionId + '"]'
      );

      const config = parseJsonElement(
        element,
        'Lab9 Mac keuzehulp: winkeladvies kon niet worden gelezen.'
      ) || { image: '', link: '' };

      return {
        image: config.image || '',
        link:
          config.link ||
          (isFrench
            ? '/fr/pages/magasins-store-locator'
            : '/pages/winkels-store-locator')
      };
    }

    function renderResults() {
      const ranking = rankRecommendationModels();
      const isFrench = isFrenchLocale();
      const storeAdvice = getStoreAdviceConfig(isFrench);

      const labels = isFrench
        ? {
            eyebrow: 'Votre recommandation',
            title: 'Les Mac qui vous correspondent le mieux',
            intro:
              'Sur la base de vos réponses, voici nos recommandations. Le premier choix correspond le mieux à votre profil, tandis que les alternatives mettent l’accent sur d’autres priorités.',
            best: 'Meilleur choix',
            alternative: 'Alternative',
            from: 'À partir de',
            why: 'Pourquoi ce choix\u202F?',
            view: 'Voir les modèles',
            displays: 'Voir les écrans',
            edit: 'Modifier mes réponses',
            restart: 'Recommencer',
            lab9Eyebrow: 'Lab9. Vous êtes au bon endroit.',
            lab9Title: 'Bien plus que le bon Mac.',
            lab9Intro:
              'Chez Lab9, vous bénéficiez aussi de services qui vous accompagnent avant et après votre achat.',
            warranty: '3 ans de garantie sur Mac',
            warrantyText: 'Pour les clients particuliers.',
            lessons: 'Cours d’introduction gratuits',
            lessonsText: 'Apprenez à tirer le meilleur parti de votre Mac.',
            tradein: 'Trade-in',
            tradeinText: 'Faites reprendre votre ancien appareil.',
            financing: 'Financement',
            financingText: 'Étalez le paiement de votre achat.',
            discover: 'En savoir plus',
            storeEyebrow: 'Conseils personnalisés en magasin',
            storeTitle: 'Vous hésitez encore\u202F?',
            storeText:
              'Passez dans un magasin Lab9. Nos experts Apple prennent le temps de comprendre vos besoins et vous aident à choisir le Mac qui vous convient.',
            storeButton: 'Trouver un magasin'
          }
        : {
            eyebrow: 'Jouw advies',
            title: 'Deze Macs passen het best bij jou',
            intro:
              'Op basis van je antwoorden raden we deze modellen aan. De eerste keuze sluit het sterkst aan bij je profiel, terwijl de alternatieven andere accenten leggen.',
            best: 'Beste match',
            alternative: 'Alternatief',
            from: 'Vanaf',
            why: 'Waarom deze past',
            view: 'Bekijk de modellen',
            displays: 'Bekijk displays',
            edit: 'Antwoorden aanpassen',
            restart: 'Opnieuw beginnen',
            lab9Eyebrow: 'Lab9. Hier zit je goed.',
            lab9Title: 'Meer dan alleen de juiste Mac.',
            lab9Intro:
              'Bij Lab9 krijg je ook diensten die je voor en na je aankoop verder helpen.',
            warranty: '3 jaar garantie op Mac',
            warrantyText: 'Voor particuliere klanten.',
            lessons: 'Gratis introductielessen',
            lessonsText: 'Haal meer uit je nieuwe Mac.',
            tradein: 'Trade-in',
            tradeinText: 'Ruil je oude toestel in.',
            financing: 'Financiering',
            financingText: 'Spreid de betaling van je aankoop.',
            discover: 'Meer info',
            storeEyebrow: 'Persoonlijk advies in de winkel',
            storeTitle: 'Nog niet helemaal zeker?',
            storeText:
              'Kom langs bij een Lab9-winkel. Onze Apple-experts luisteren naar wat je nodig hebt en helpen je de juiste Mac kiezen.',
            storeButton: 'Vind een winkel'
          };

      if (!ranking.length) {
        mount.innerHTML = isFrench
          ? '<p>Aucun modèle Mac adapté n’a été trouvé.</p>'
          : '<p>Geen geschikte Mac-modellen gevonden.</p>';
        scrollMacChoiceToTop();
        return;
      }

      const cards = ranking
        .map(function (item, index) {
          const model = item.model;
          const isBest = index === 0;
          const reasons = getMacResultReasons(model, isFrench);
          const modelUrl = getLocalizedMacPath(model.collectionUrl, isFrench);
          const displayUrl = isFrench
            ? '/fr/pages/ecrans'
            : '/pages/beeldschermen';
          const showDisplayButton =
            !isPortableModel(model) && model.familyHandle !== 'imac';

          const resultImage =
  model.familyHandle === 'mac-mini'
    ? 'https://cdn.shopify.com/s/files/1/0786/7806/5453/files/mac-mini-FIX.png?v=1787731046'
    : model.image;

const image = resultImage
  ? `
      <img
        src="${escapeHtml(resultImage)}"
        alt="${escapeHtml(model.name)}"
        loading="lazy"
      >
    `
  : '';

          const reasonsHtml = reasons
            .map(function (reason) {
              return `<li>${escapeHtml(reason)}</li>`;
            })
            .join('');

          return `
            <article class="lab9-mac-choice-helper__result-card${
              isBest ? ' lab9-mac-choice-helper__result-card--best' : ''
            }">
              <div class="lab9-mac-choice-helper__result-visual">
                ${image}
              </div>

              <div class="lab9-mac-choice-helper__result-body">
                <div class="lab9-mac-choice-helper__result-badge">
                  ${isBest ? labels.best : labels.alternative}
                </div>

                <h3 class="lab9-mac-choice-helper__result-name">
                  ${escapeHtml(model.name)}
                </h3>

                <p class="lab9-mac-choice-helper__result-price">
                  ${labels.from} <strong>${formatPrice(model.price)}</strong>
                </p>

                <div class="lab9-mac-choice-helper__result-reasons">
                  <strong>${labels.why}</strong>
                  <ul>${reasonsHtml}</ul>
                </div>

                <div class="lab9-mac-choice-helper__result-actions">
                  <a
                    href="${escapeHtml(modelUrl)}"
                    class="lab9-mac-choice-helper__result-button"
                  >
                    ${labels.view}
                  </a>

                  ${
                    showDisplayButton
                      ? `
                        <a
                          href="${escapeHtml(displayUrl)}"
                          class="lab9-mac-choice-helper__result-button lab9-mac-choice-helper__result-button--secondary"
                        >
                          ${labels.displays}
                        </a>
                      `
                      : ''
                  }
                </div>
              </div>
            </article>
          `;
        })
        .join('');

      const warrantyUrl = isFrench
        ? '/fr/pages/garantie-de-3-ans'
        : '/pages/3-jaar-garantie';
      const lessonsUrl = isFrench
        ? '/fr/pages/cours-gratuit'
        : '/pages/gratis-lessen';
      const tradeInUrl = isFrench
        ? '/fr/pages/trade-in'
        : '/pages/trade-in';
      const financingUrl = isFrench
        ? '/fr/pages/financement'
        : '/pages/financiering';

      const storeImageHtml = storeAdvice.image
        ? `
          <div class="lab9-mac-choice-helper__store-advice-media">
            <img
              src="${escapeHtml(storeAdvice.image)}"
              alt="${escapeHtml(labels.storeTitle)}"
              loading="lazy"
            >
          </div>
        `
        : '';

      mount.innerHTML = `
        <div class="lab9-mac-choice-helper__results">
          <header class="lab9-mac-choice-helper__results-header">
            <p class="lab9-mac-choice-helper__eyebrow">${labels.eyebrow}</p>
            <h2>${labels.title}</h2>
            <p>${labels.intro}</p>
          </header>

          <div class="lab9-mac-choice-helper__results-grid">
            ${cards}
          </div>

          <div class="lab9-mac-choice-helper__result-navigation">
            <button
              type="button"
              class="lab9-mac-choice-helper__result-button lab9-mac-choice-helper__result-button--secondary"
              data-action="edit"
            >
              ${labels.edit}
            </button>

            <button
              type="button"
              class="lab9-mac-choice-helper__result-button lab9-mac-choice-helper__result-button--secondary"
              data-action="restart"
            >
              ${labels.restart}
            </button>
          </div>

          <section class="lab9-mac-choice-helper__benefits">
            <div class="lab9-mac-choice-helper__benefits-header">
              <p class="lab9-mac-choice-helper__eyebrow">${labels.lab9Eyebrow}</p>
              <h2>${labels.lab9Title}</h2>
              <p>${labels.lab9Intro}</p>
            </div>

            <div class="lab9-mac-choice-helper__benefits-grid">
              <a href="${escapeHtml(warrantyUrl)}" class="lab9-mac-choice-helper__benefit">
                ${getMacBenefitIcon('warranty')}
                <strong>${labels.warranty}</strong>
                <span>${labels.warrantyText}</span>
                <small>${labels.discover} →</small>
              </a>

              <a href="${escapeHtml(lessonsUrl)}" class="lab9-mac-choice-helper__benefit">
                ${getMacBenefitIcon('lessons')}
                <strong>${labels.lessons}</strong>
                <span>${labels.lessonsText}</span>
                <small>${labels.discover} →</small>
              </a>

              <a href="${escapeHtml(tradeInUrl)}" class="lab9-mac-choice-helper__benefit">
                ${getMacBenefitIcon('tradein')}
                <strong>${labels.tradein}</strong>
                <span>${labels.tradeinText}</span>
                <small>${labels.discover} →</small>
              </a>

              <a href="${escapeHtml(financingUrl)}" class="lab9-mac-choice-helper__benefit">
                ${getMacBenefitIcon('financing')}
                <strong>${labels.financing}</strong>
                <span>${labels.financingText}</span>
                <small>${labels.discover} →</small>
              </a>
            </div>
          </section>

          <section class="lab9-mac-choice-helper__store-advice${
            storeAdvice.image ? '' : ' lab9-mac-choice-helper__store-advice--no-image'
          }">
            <div class="lab9-mac-choice-helper__store-advice-content">
              <p class="lab9-mac-choice-helper__eyebrow">${labels.storeEyebrow}</p>
              <h2>${labels.storeTitle}</h2>
              <p>${labels.storeText}</p>
              <a
                href="${escapeHtml(storeAdvice.link)}"
                class="lab9-mac-choice-helper__result-button"
              >
                ${labels.storeButton}
              </a>
            </div>
            ${storeImageHtml}
          </section>
        </div>
      `;

      scrollMacChoiceToTop();
    }

    section.addEventListener('click', function (event) {
      const actionButton = event.target.closest('[data-action]');

      if (actionButton && section.contains(actionButton)) {
        const action = actionButton.dataset.action;

        if (action === 'edit') {
          state.step = 0;
          renderQuestion();
          return;
        }

        if (action === 'restart') {
          renderWelcome();
          return;
        }
      }

      const startButton = event.target.closest('[data-mac-choice-start]');

      if (startButton && section.contains(startButton)) {
        state.mode = 'full';
        state.step = 0;
        state.answers = {};
        renderQuestion();
        return;
      }

      const shortcutButton = event.target.closest(
        '[data-mac-choice-shortcut]'
      );

      if (shortcutButton && section.contains(shortcutButton)) {
        state.mode = shortcutButton.dataset.macChoiceShortcut;
        state.step = 0;
        state.answers = {};
        renderQuestion();
        return;
      }

      const answerButton = event.target.closest('[data-mac-choice-answer]');

      if (answerButton && section.contains(answerButton)) {
        const questions = getQuestions();
        const question = questions[state.step];

        if (!question) return;

        state.answers[question.key] = answerButton.dataset.macChoiceAnswer;

        mount
          .querySelectorAll('[data-mac-choice-answer]')
          .forEach(function (button) {
            button.classList.remove('is-selected');
          });

        answerButton.classList.add('is-selected');

        const nextButton = mount.querySelector('[data-mac-choice-next]');
        if (nextButton) nextButton.disabled = false;
        return;
      }

      const nextButton = event.target.closest('[data-mac-choice-next]');

      if (nextButton && section.contains(nextButton)) {
        const questions = getQuestions();
        const question = questions[state.step];

        if (!question || !state.answers[question.key]) return;

        if (state.step < questions.length - 1) {
          state.step += 1;
          renderQuestion();
        } else {
          renderResults();
        }
        return;
      }

      const backButton = event.target.closest('[data-mac-choice-back]');

      if (backButton && section.contains(backButton)) {
        if (state.step === 0) {
          renderWelcome();
        } else {
          state.step -= 1;
          renderQuestion();
        }
      }
    });
  }

  function initAll(root) {
    getSections(root).forEach(function (section) {
      initMacProductData(section);
      initMacChoiceHelper(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
